import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../util';

import { EAssemblyOrderStatus } from './../../../assembly-order/interfaces/assembly-order.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class AssemblyOrderApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getComposedBomItems(
    bomId :number = 0,
    params ?:{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/bom/${bomId}/composed-items`,
      { params },
    );
  }

  getItemLocationsByRfq(
    rfqId :number = 0,
    params ?:{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/bom/locations/${rfqId}`, {
      params,
    });
  }

  create(data :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/assembly-orders`,
      body: data,
    });
  }

  createByOrderLineItems(payload :{
    orderItemIds :number[];
    orderStatus :EAssemblyOrderStatus;
  }) :Observable<any> {
    const { orderItemIds, orderStatus } = payload;

    return this.apiService.post({
      path: `${this.environment.urlV2}/assembly-orders/auto-create-from-sales-order-items`,
      body: { orderItemIds, orderStatus },
    });
  }

  get(params ?:{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/assembly-orders`, {
      params,
    });
  }

  updateStatus(id :number, data :{ [column :string] :string }) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/assembly-orders/${id}/status`,
      data,
    );
  }

  getById(
    id :number,
    params ?:{ [param :string] :string | string[] },
  ) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/assembly-orders/${id}`, {
      params,
    });
  }

  update(id :number, data :any) :Observable<any> {
    return this.apiService.put(
      `${this.environment.urlV2}/assembly-orders/${id}`,
      data,
    );
  }

  delete(id :number) :Observable<any> {
    return this.apiService.delete(
      `${this.environment.urlV2}/assembly-orders/${id}`,
    );
  }

  exportOrder(
    orderId :number,
    params ?:{
      [key :string] :string | string[];
    },
  ) :Observable<any> {
    return this.apiService.getBlob(
      `${this.environment.urlV2}/assembly-orders/export/${orderId}`,
      {
        params: params,
      },
    );
  }

  getLineItems(params :{ [param :string] :string | string[] }) :Observable<any> {
    return this.apiService.get(`${this.environment.urlV2}/assembly-orders/items`, {
      params,
    });
  }
}
